import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PlanDrawer from "../components/PlanDrawer";

const PlanDrawerContext = createContext(null);

export function PlanDrawerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openDrawer = useCallback(() => setOpen(true), []);
  const closeDrawer = useCallback(() => setOpen(false), []);
  const value = useMemo(
    () => ({ open, setOpen, openDrawer, closeDrawer }),
    [open, openDrawer, closeDrawer]
  );
  return (
    <PlanDrawerContext.Provider value={value}>
      {children}
      <PlanDrawer />
    </PlanDrawerContext.Provider>
  );
}

export function usePlanDrawer() {
  const ctx = useContext(PlanDrawerContext);
  if (!ctx) throw new Error("usePlanDrawer must be used within PlanDrawerProvider");
  return ctx;
}
